import { render, staticRenderFns } from "./DocuSignConfig.vue?vue&type=template&id=20a2a910&scoped=true&"
import script from "./DocuSignConfig.vue?vue&type=script&lang=js&"
export * from "./DocuSignConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a2a910",
  null
  
)

export default component.exports